import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "./dialog-title/DialogTitle";
import GenericDialogActions from "./generic-dialog-actions/GenericDialogActions";
import * as PropTypes from "prop-types";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import {theme} from "../../../../shared/theme";
import {CircularProgress, DialogContent} from "@material-ui/core";
import Error from "../../../../shared/components/error/Error";

const useStyles = makeStyles({
    root: {
        overflowY: "initial",
        paddingBottom: theme.spacing(1),
        "& > :not(:last-child)": {
            marginBottom: theme.spacing(4),
        },
    },
});

const NoPaddingDialogContent = withStyles({
    root: {
        padding: "0px 0px",
        marginTop: "1%",
    }
})(DialogContent)

const GenericDialog = (props) => {
    const classes = useStyles();

    return (
        <Dialog
            PaperProps={{
                style: {
                    paddingLeft: "10px",
                    paddingRight: "16px",
                },
            }}
            fullWidth={true}
            maxWidth={props.loading || props.error ? "sm" : props.dialogWidth}
            onClose={props.handleDialogClose}
            aria-labelledby="customized-dialog-title"
            open={props.open}
        >
            <DialogTitle className="mr-35" onClose={props.handleDialogCloseButton}>
                {!props.loading && !props.error ? props.children : null}
            </DialogTitle>
            {!props.error ? !props.loading ? (
                <NoPaddingDialogContent             onScroll={props.onScroll}>
                    <DialogContent className={classes.root}>{props.dialogContent}</DialogContent>
                </NoPaddingDialogContent>
            ) : (
                <div className="text-center">
                    <CircularProgress size={64}/>
                </div>
            ) : <Error errorText={props.errorText} icon={props.errorIcon}/>}

            <GenericDialogActions dialogActions={!props.loading && !props.error ? props.dialogActions : null}/>
        </Dialog>
    );
};

GenericDialog.propTypes = {
    dialogWidth: PropTypes.string,
    dialogContent: PropTypes.element,
    dialogActions: PropTypes.element,
    open: PropTypes.bool,
    handleDialogClose: PropTypes.func,
    handleDialogCloseButton: PropTypes.func,
    loading: PropTypes.bool,
    error: PropTypes.bool,
    errorIcon: PropTypes.object,
    errorText: PropTypes.string
};

GenericDialog.defaultProps = {
    loading: false,
    error: false
}

export default GenericDialog;
